<template>
  <div class="DistributionSystem mainPageBg">
    <div class="leftBox">
      <TreeMenu @getActiveItem="getActiveItem" :pageName="'配电系统'" />
    </div>
    <div class="rightBox ashComWrap">
      <div class="top">
        <div class="top-title">配电系统</div>
        <div class="top-content">
          <div
            class="top-content-item"
            v-for="item in titleData"
            :key="item.name"
          >
            <div class="top-content-item-name">{{ item.name }}</div>
            <div class="top-content-item-num">{{ `${item.num}个` }}</div>
          </div>
        </div>
      </div>
      <div class="bottom">
        <div class="bottom-left">
          <div class="ashComWrap bottom-left-line">
            <TrendLine :assetId="assetId"/>
          </div>
          <div class="bottom-left-svg" id="svgContent">
            <SvgD3
              :key="svgKey"
              svgId="svgPowerDistribution"
              :svgUrl="svgUrl"
              :svgUrlType="svgUrlType"
              :clientHeightOffset="5"
              :showBorder="false"
            />
          </div>
          <div class="bottom-left-table">
            <div class="ashComWrap bottom-left-table-warning">
              <TableWithJump
                titleName="报警"
                :tableData="alarmTableData"
                :tableDataHead="alarmTableHead"
                :jumpUrl="{
                  name: 'distributingDevOps',
                  params: { id: '告警' },
                }"
                :showTopTips="false"
              />
            </div>
            <div class="ashComWrap bottom-left-table-inspection">
              <TableWithJump
                titleName="巡检"
                :tableData="inspectionTableData"
                :tableDataHead="inspectionTableHead"
                jumpUrl="/distributingDevOps"
                :showTopTips="false"
              />
            </div>
          </div>
        </div>
        <div class="bottom-right">
          <div class="bottom-right-first">
            <div class="ashComWrap bottom-right-first-basic">
              <div class="comTitle">
                <h4>基本信息</h4>
              </div>
              <div class="comContentBox">
                <TipsWrap v-if="1" :listData="basicData" />
                <el-empty
                  v-else
                  class="empty"
                  :image-size="50"
                  description="暂无数据"
                ></el-empty>
              </div>
            </div>
            <div class="ashComWrap bottom-right-first-state">
              <div class="comTitle">
                <h4>运行状态</h4>
                <div>
                  <el-button
                    type="text"
                    size="mini"
                    style="color: #999999; margin: 0 10px"
                    @click="$router.push(jumpUrl)"
                    >更多 <i class="el-icon-d-arrow-right"></i
                  ></el-button>
                </div>
              </div>
              <div class="comContentBox">
                <TipsWrap v-if="1" :listData="stateData" />
                <el-empty
                  v-else
                  class="empty"
                  :image-size="50"
                  description="暂无数据"
                ></el-empty>
              </div>
            </div>
          </div>
          <div class="bottom-right-video ashComWrap">
            <div class="comTitle">
              <h4>视频信息</h4>
              <div>
                <el-button
                  type="text"
                  size="mini"
                  style="color: #999999; margin: 0 10px"
                  @click="$router.push(jumpUrlVideo)"
                  >更多 <i class="el-icon-d-arrow-right"></i
                ></el-button>
              </div>
            </div>
            <div class="comContentBox bottom-right-video-content">
              <VideoPlayerWithPagination
                v-if="assetId"
                videoId="videoDBSystem"
                systemType="配电"
                :assetId="assetId"
              />
              <template v-else>
                <div style="width: 100%; height: 250px; display: inline-block">
                  <el-image
                    style="width: 100%; height: 100%"
                    :src="require('@/assets/images/video/noVideo.svg')"
                    fit="fill"
                  ></el-image>
                </div>
              </template>
            </div>
          </div>
          <div class="ashComWrap bottom-right-environment">
            <div class="comTitle">
              <h4>环境监测</h4>
              <div>
                <el-button
                  type="text"
                  size="mini"
                  style="color: #999999; margin: 0 10px"
                  @click="$router.push(jumpUrlEnv)"
                  >更多 <i class="el-icon-d-arrow-right"></i
                ></el-button>
              </div>
            </div>
            <div class="comContentBox">
              <div
                v-if="envMonitorData.length"
                class="bottom-right-environment-content"
              >
                <EnvMonitor :envMonitorData="envMonitorData" />
              </div>
              <el-empty
                v-else
                class="empty-mini"
                :image-size="30"
                description="暂无数据"
              ></el-empty>
            </div>
          </div>
          <div class="ashComWrap bottom-right-environment">
            <div class="comTitle">
              <h4>传感器</h4>
              <!-- <div>
                <el-button
                  type="text"
                  size="mini"
                  style="color: #999999; margin: 0 10px"
                  @click="$router.push(jumpUrl)"
                  >更多 <i class="el-icon-d-arrow-right"></i
                ></el-button>
              </div> -->
            </div>
            <div class="comContentBox">
              <div
                v-if="sensorData.length"
                class="bottom-right-environment-content"
              >
                <EnvMonitor :envMonitorData="sensorData" />
              </div>
              <el-empty
                v-else
                class="empty-mini"
                :image-size="30"
                description="暂无数据"
              ></el-empty>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TreeMenu from "@/components/zixitong/TreeMenu";
import TrendLine from "@/components/zixitong/distributionSystem/distributionSystem/TrendLine";
import EnvMonitor from "@/components/zixitong/distributionSystem/distributionSystem/EnvMonitor";
import SvgD3 from "@/components/Svg/SvgD3";
import TipsWrap from "@/components/TitleTips/TipsWrap";
import TableWithJump from "@/components/TableWithJump/TableWithJump";
import VideoPlayerWithPagination from "@/components/VideoPlayer/VideoPlayerWithPagination";
import api from "@/api";
import {
  getProjectVal,
  dealNumWith,
  dateFtt,
  matchingAlarmLevel,
  getUserInfoVal,
} from "@/assets/js/utils";
export default {
  name: "DistributionSystem",
  props: {},
  components: {
    TreeMenu,
    VideoPlayerWithPagination,
    SvgD3,
    TableWithJump,
    TipsWrap,
    TrendLine,
    EnvMonitor,
  },
  data() {
    return {
      titleData: [],
      basicData: [],
      stateData: [],
      assetId: "",
      svgKey: 1,
      svgUrl: "@/assets/images/svg/empty.svg",
      jumpUrlEnv: "/IndoorsDataDetails",
      centerTabs: [],
      envMonitorData: [],
      sensorData: [],
      //报警
      alarmTableData: [],
      alarmTableHead: [
        { label: "报警时间", prop: "time" },
        { label: "处理状态", prop: "confirm" },
        { label: "报警级别", prop: "level" },
      ],
      //巡检
      inspectionTableData: [],
      inspectionTableHead: [
        { label: "巡检时间", prop: "clockTime" },
        { label: "巡检点位", prop: "point" },
        { label: "巡检人", prop: "planUser" },
      ],
    };
  },
  computed: {
    svgUrlType: function () {
      return this.svgUrl.includes("@/assets") ? "path" : "url";
    },
    jumpUrl: function () {
      return { name: "distributingRun", params: { assetId: this.assetId } };
    },
    jumpUrlVideo: function () {
      return { name: "distributingMonitor", params: { assetId: this.assetId } };
    },
  },
  watch: {
    svgUrl(val) {
      this.svgKey = new Date().getTime();
    },
  },
  methods: {
    getActiveItem(data) {
      console.log("----getActiveItem--data--", data);
      this.assetId = data.id;
      this.getOverviewOfPowerDistribution(data.id);
      this.getBasicInformation(data.id);
      this.getRunningState(data.id);
      this.getEnvironmentalMonitoring(data.id, "环境监测");
      this.getEnvironmentalMonitoring(data.id, "配电系统");
      this.getAlarmsPageByAssetType(data.id);
      this.getTelemetryAndAttributeValues(data.id);
      this.getPatrolTable(data.id);
    },
    async getAlarmsPageByAssetType(assetId) {
      this.alarmTableData = [];
      let res = await api.DSGetAlarmsPageByAssetType({
        projectId: getProjectVal("Id"),
        assetId,
        assetType: "配电系统",
        pageSize: 5,
        page: 0,
      });
      if (res && res.data.code == 200) {
        this.alarmTableData = res.data.data.data.map((v) => ({
          time: v.endTime
            ? dateFtt("yyyy-MM-dd hh:mm:ss", new Date(v.endTime))
            : "",
          confirm: v.confirm ? "已确认" : "未确认",
          level: matchingAlarmLevel(v.level),
        }));
      }
    },
    /************ 巡检记录 ***********/
    async getPatrolTable(assetId) {
      this.inspectionTableData = [];
      let res = await api.devOpsPatrolTable({
        projectId: getProjectVal("Id"),
        startTime: this.$moment()
          .startOf("day")
          .subtract(6, "days")
          .format("x"),
        endTime: this.$moment().endOf("day").format("x"),
        pageSize: 5,
        page: 0,
        deviceType: "配电系统",
        sourceType: "INSPECTION",
        assetId,
      });
      if (res && res.data.code == 200) {
        this.inspectionTableData = res.data.data.data.map((v) => ({
          ...v,
          planTime: `${dateFtt(
            "yyyy-MM-dd hh:mm:ss",
            new Date(v.startts)
          )}-${dateFtt("yyyy-MM-dd hh:mm:ss", new Date(v.endts))}`,
          clockTime:
            v.actts && v.actts != 0
              ? dateFtt("yyyy-MM-dd hh:mm:ss", new Date(v.actts))
              : "-",
          planUser:
            v.staffinfo && v.staffinfo != "null"
              ? JSON.parse(v.staffinfo)
                  .map((v) => {
                    return v.name;
                  })
                  .join(",")
              : "-",
        }));
      }
    },
    //概览
    async getOverviewOfPowerDistribution(assetId) {
      this.titleData = [];
      let res = await api.DSGetOverviewOfPowerDistribution({
        assetId,
        assetType: "配电系统",
      });
      if (res && res.data.code == 200) {
        this.titleData = res.data.data.map((item) => ({
          ...item,
          num: item.value,
        }));
      } else {
        console.log("获取概览失败");
      }
    },
    //基本信息
    async getBasicInformation(assetId) {
      this.basicData = [
        {
          name: "额定容量",
          value: 0,
          unit: "kVA",
        },
        {
          name: "回路",
          value: 0,
        },
        {
          name: "测控设备",
          value: 0,
        },
      ];
      let res = await api.DSGetBasicInformation({
        assetId,
        assetType: "配电系统",
        deviceTypes: "电表,单相电表,三相电表",
      });
      if (res && res.data.code == 200) {
        const { deviceCount, loop, capacity } = res.data.data;
        this.basicData = [
          {
            name: "额定容量",
            value: dealNumWith(capacity, 0),
            unit: "kVA",
          },
          {
            name: "回路",
            value: loop,
          },
          {
            name: "测控设备",
            value: deviceCount,
          },
        ];
      } else {
        console.log("获取基本信息失败");
      }
    },
    //运行状态
    async getRunningState(assetId) {
      this.stateData = [
        {
          name: "有功功率",
          value: 0,
          unit: "kw",
        },
        {
          name: "无功功率",
          value: 0,
          unit: "kvar",
        },
        {
          name: "负载率",
          value: "0%",
        },
      ];
      let res = await api.DSGetRunningState({
        assetId,
        assetType: "配电系统",
        deviceTypes: "电表,单相电表,三相电表",
      });
      if (res && res.data.code == 200) {
        this.stateData = res.data.data.map((item) => {
          if (item.name === "负载率") {
            return {
              name: item.name,
              value: `${item.value}%`,
            };
          } else {
            return {
              ...item,
            };
          }
        });
      } else {
        console.log("获取运行状态失败");
      }
    },
    //环境监测,传感器
    async getEnvironmentalMonitoring(assetId, modular) {
      if (modular === "环境监测") {
        this.envMonitorData = [];
      } else {
        this.sensorData = [];
      }
      let res = await api.ACRGetEnvironmentalMonitoring({
        projectId: getProjectVal("Id"),
        assetId,
        modular,
      });
      if (res && res.data.code == 200) {
        if (modular === "环境监测") {
          this.envMonitorData = res.data.data;
        } else {
          this.sensorData = res.data.data;
        }
      } else {
        console.log(`获取${modular}失败`);
      }
    },
    //svg
    async getTelemetryAndAttributeValues(assetId) {
      this.svgUrl = "@/assets/images/svg/empty.svg";
      let res = await api.SVGGetTelemetryAndAttributeValues({
        deviceIds: assetId,
        keys: "DistributionDiagram",
        keyType: "attribute",
      });
      if (
        res &&
        res.data.code == 200 &&
        res.data.data[0]?.value &&
        res.data.data[0].value != "-1"
      ) {
        this.svgUrl = `${res.data.data[0].value}?tenant_id=${getUserInfoVal(
          "tenantId"
        )}`;
      } else {
        console.log("获取svg失败");
      }
    },
  },
  created() {},
  mounted() {},
};
</script>

<style lang="scss" scoped>
.DistributionSystem {
  @include setFlexBetween;
  .leftBox {
    @include setMenuWH;
  }
  .rightBox {
    @include setCenterWHPaddingScroll;
    background-color: #f7f7f7;
    .top {
      margin-top: 16px;
      width: 100%;
      height: 40px;
      border-radius: 4px;
      background: #fff;
      @include setFlexBetween;
      &-title {
        font-size: 15px;
        text-indent: 10px;
        color: #5f6b67;
        font-weight: 700;
      }
      &-content {
        font-size: 14px;
        width: 600px;
        @include setFlexAround;
        &-item {
          width: 130px;
          @include setFlexStart;
          &-name {
            width: 75px;
          }
          &-num {
            color: #333;
            margin-left: 10px;
          }
        }
      }
    }
    .bottom {
      width: 100%;
      margin-top: 12px;
      margin-bottom: 16px;
      @include setFlexBetween;
      &-left {
        width: calc(100% - 412px);
        &-line {
          height: 200px;
        }
        &-svg {
          margin-top: 12px;
          height: 500px;
        }
        &-table {
          margin-top: 12px;
          height: 252px;
          @include setFlexBetween;
          & > div {
            width: $halfWidth;
            height: 100%;
          }
        }
      }
      &-right {
        width: 400px;
        &-first {
          height: 200px;
          @include setFlexBetween;
          & > div {
            width: $halfWidth;
            height: 100%;
          }
        }
        &-video {
          margin-top: 12px;
          height: 500px;
          &-content {
            padding: 0 16px;
            width: calc(100% - 32px);
          }
        }
        &-environment {
          margin-top: 12px;
          height: 120px;
          &-content {
            width: calc(100% - 32px);
            margin: 0 16px;
            @include setFlexStart;
          }
        }
      }
    }
    .empty-mini {
      padding: 2px 0;
    }
  }
}
</style>
